// 面包屑对应名字
const breadcrumbNameMap = {
  "/system": "系统管理",
  "/system/authorization": "权限设置",
  "/system/role": "角色管理",
  "/device": "设备管理",
  "/device/deviceHome": "设备首页",
  "/device/commandIssued": "已发命令列表",
  "/device/BatchList": "批次号列表",
  "/home": "主页",
  "/personalCenter": "个人中心",
  "/personalCenter/myInfo": "个人信息",
  "/personalCenter/changeWpd": "修改密码",
  "/device/paixiang": "派享x86",
  "/device/history": "历史记录",
  "/device/pressureMeasurement": "压测记录",
};

export default breadcrumbNameMap;
